import "./MapLayerControl.css";

import { MAP_DISPLAY_MODES, isResultsTab } from "../../constants";
import { useDispatch, useSelector } from "react-redux";

import { Scouting } from "./components/Scouting/Scouting";
import { TrialInformation } from "./components/TrialInformation/TrialInformation";
import chroma from "chroma-js";
import { setSelectedPlotId } from "../../actions/resultMap";
import { useState } from "react";

export const MapLayerControl = () => {
  const dispatch = useDispatch();
  // By name: the menu objects below are rebuilt on every render, so comparing
  // them by identity never matched (the icon could not close its own menu).
  const [selectedMenuName, setSelectedMenuName] = useState(null);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [mapDisplayMode, selectedPlotId] = useSelector(({ resultMap }) => [
    resultMap.mapDisplayMode,
    resultMap.selectedPlotId,
  ]);

  // The menu and the plot view take the same corner: opening a plot closes the
  // menu, as opening a menu closes the plot (onClick below).
  const [prevPlotId, setPrevPlotId] = useState(selectedPlotId);
  if (selectedPlotId !== prevPlotId) {
    setPrevPlotId(selectedPlotId);
    if (selectedPlotId) setSelectedMenuName(null);
  }

  const MAP_LAYER_CONTROL_MENUS = [
    {
      name: "Trial",
      icon: (
        <div
          // Field Book is part of the Results tab: same diorama.
          className={`diorama-${
            isResultsTab(mapDisplayMode)
              ? MAP_DISPLAY_MODES.RESULTS
              : mapDisplayMode
          }`}
          style={{ maxWidth: "120%" }}
        />
      ),
      color: "#8fbf48",
      component: <TrialInformation />,
    },
    {
      name: "Scouting",
      icon: <i className="fa-solid fa-camera fa-lg" />,
      color: "#D32F2F",
      component: <Scouting />,
    },
  ];

  const selectedMenu = MAP_LAYER_CONTROL_MENUS.find(
    ({ name }) => name === selectedMenuName
  );
  const displayMenu = selectedMenu || hoveredMenu;

  return (
    <div className={`map-layer-control w-100 ${selectedMenu ? "active" : ""}`}>
      <div
        className={`map-layer-control-header d-flex flex-row align-items-center gap-3 ps-3 pe-3 clickable ${
          selectedMenu ? "active" : ""
        } justify-content-between`}
        onClick={() => {
          setSelectedMenuName(null);
        }}
      >
        <div
          className={`map-layer-control-header-list  ${
            selectedMenu ? "active" : ""
          }`}
        >
          <div className="map-layer-control-header-items">
            {MAP_LAYER_CONTROL_MENUS.map((menu) => (
              <div
                key={menu.name}
                className={`map-layer-control-header-item clickable ${
                  selectedMenuName === menu.name ? "active" : ""
                }`}
                style={{
                  color: menu.color,
                  backgroundColor: chroma(menu.color).brighten(2.5).hex(),
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (selectedMenuName === menu.name) {
                    setSelectedMenuName(null);
                    return;
                  }
                  // The opened menu grows over the plot view: close the plot.
                  dispatch(setSelectedPlotId(null));
                  setSelectedMenuName(menu.name);
                }}
                onMouseEnter={() => setHoveredMenu(menu)}
                onMouseLeave={() => setHoveredMenu(null)}
              >
                {menu.icon}
              </div>
            ))}
          </div>
          <div>
            {displayMenu && (
              <span
                className="font-weight-bold mx-1"
                style={{ color: displayMenu.color }}
              >
                {displayMenu.name}
              </span>
            )}
            {selectedMenu && <i className="fa-solid fa-angle-down" />}
          </div>
        </div>
      </div>
      {selectedMenu && (
        <div className="map-layer-control-content">
          {selectedMenu.component}
        </div>
      )}
    </div>
  );
};
